import { useTranslation } from "react-i18next";
import { useGetData } from "../service";
import UpdateFormHead from "components/subHead/updateFromHead";
import {
  UPDATE_BASE_FORM_ID_ROOM_ROOM,
  UPDATE_IMG_FORM_ID_ROOM_ROOM,
} from "components/constent";
import BaseInfForm from "../baseInfForm";
import DetailFormHead from "components/subHead/detailFormHead";
import { RoomImageProvider, useRoomAddInfContext } from "../context";
import RoomImgUpdate from "./imgupdate";
import useMultiLangStore from "store/multiLang";
import MultiFormHead from "components/subHead/multiFormHead";
import { useEditedLang, useSetBaseInf } from "./handlers";
import MultilingualForm from "../multilingualForm";
import NoInf from "components/noInf";
import RoomImageManager from "../image";
import { ImagesProvider, useImagesContext } from "../image/context";

type IImgProps = {
  imgList: any;
};

const UpdateImg = ({ imgList }: IImgProps) => {
  const { t } = useTranslation();

  return (
    <>
      <DetailFormHead title={t("row_ttl_rm_img")} />
      <RoomImgUpdate imgList={imgList} />
    </>
  );
};
export default function RoomUpdate() {
  const { t } = useTranslation();
  const { getDefaultValue } = useRoomAddInfContext();
  const { baseInf, addInf, imgList } = useGetData({ modalNm: "update" });
  const multiLang = useMultiLangStore((state) => state.multiLang);

  const savedLangs =
    addInf.length !== 0 ? addInf.map((inf: any) => inf.langCd) : [];

  const baseValue = getDefaultValue(multiLang) || {};

  const { setBasetInf } = useSetBaseInf();
  const { editedLang } = useEditedLang();

  return (
    <>
      {/* 기본정보 상세 */}
      <UpdateFormHead
        title={t("row_ttl_default")}
        formId={UPDATE_BASE_FORM_ID_ROOM_ROOM}
      />
      {!baseInf && <BaseInfForm baseInf={null} formTyp={"update"} />}
      {baseInf && <BaseInfForm baseInf={baseInf} formTyp={"update"} />}

      {/* 다국어 정보 */}
      <MultiFormHead
        title={t("row_ttl_add_inf")}
        formId={
          UPDATE_BASE_FORM_ID_ROOM_ROOM + "-" + (multiLang || savedLangs[0])
        }
        savedLangs={savedLangs}
        setBasetInf={setBasetInf}
        editedLang={editedLang}
      />
      {/* 등록된 정보가 없을 시 기본 폼 제공 */}
      <div>
        {!multiLang && addInf.length === 0 && (
          <NoInf sub="언어버튼을 클릭하여 폼을 추가하여 주세요." />
        )}

        {addInf.length !== 0 && (
          <>
            {addInf.map((inf: any) => {
              return (
                <MultilingualForm
                  key={inf.langCd}
                  inf={
                    inf.langCd === multiLang
                      ? {
                          ...inf,
                          ...baseValue,
                        }
                      : inf
                  }
                  updateAble="true"
                  formTyp={"update"}
                  formId={UPDATE_BASE_FORM_ID_ROOM_ROOM + "-" + inf.langCd}
                />
              );
            })}
          </>
        )}
        {!!multiLang && !savedLangs.includes(multiLang) && (
          <MultilingualForm
            inf={{
              langCd: multiLang,
              ...baseValue,
            }}
            formTyp={"create"}
            formId={
              UPDATE_BASE_FORM_ID_ROOM_ROOM + "-" + (multiLang || savedLangs[0])
            }
          />
        )}
      </div>

      {/* 이미지 */}
      <ImagesProvider>
        <RoomImageManager
          rmNo={baseInf?.rmNo || null}
          initialImages={imgList}
          formId={UPDATE_IMG_FORM_ID_ROOM_ROOM}
          btnTxt={"저장"}
        />
      </ImagesProvider>
      {/* <RoomImageProvider> */}
      {/* <RoomImgUpdate imgList={imgList} rmNo={baseInf?.rmNo} /> */}

      {/* </RoomImageProvider> */}
    </>
  );
}
